import axios from "axios";
import { getAccessToken, getCompanyId, getUserId } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
export const FETCH_IG_HASHTAGS = "FETCH_IG_HASHTAGS";
export const ACTIVE_BUSINESS_ACCOUNT = "ACTIVE_BUSINESS_ACCOUNT";
export const GET_PROGRESS = "GET_PROGRESS";
import { updateProgressBarInfo } from "./queryBuilderActions";

export function fetchIGHashTags() {
    let param = {};
    param["config_type"] = "InstagramGraphHashtag";
    param["access-token"] = getAccessToken();

    let res = axios
        .post(getUrl("getIgHashTags"), param, {
            cache: false,
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((resp) => resp.data)
        .catch((err) => toast.error(err.response.data.message));

    return {
        payload: res,
        type: FETCH_IG_HASHTAGS,
    };
}

export function addIGHashTags(params) {
    let progressBarParams = {};
    let config = {};
    config["instagramDataConfigured"] = 1;
    progressBarParams["company_id"] = getCompanyId();
    progressBarParams["user_id"] = getUserId();
    progressBarParams["progress_config"] = config;
    return function (dispatch) {
        params["access-token"] = getAccessToken();
        let res = axios
            .post(getUrl("addIgHashTags"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((res) => {
                dispatch(fetchIGHashTags()).then(() => {
                    dispatch(updateProgressBarInfo(progressBarParams));
                });
                toast.success("Hashtag configured successfully.");
            })
            .catch((err) => {
                console.log(err.response);
                if (
                    err.response &&
                    err.response.data &&
                    err.response.data.message === "An unknown error occured with this token. try different business account"
                ) {
                    toast.error("The hashtag is invalid. There is no post with this hashtag.");
                } else {
                    const errorMessage =
                        err.response && err.response.data && err.response.data.message ? err.response.data.message : "An error occurred. Please try again.";
                    toast.error(errorMessage);
                }
            });
    };
}
export function deleteIGHashTag(params) {
    return function (dispatch) {
        params["access-token"] = getAccessToken();
        let res = axios
            .post(getUrl("deleteIgHashTags"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((resp) => {
                dispatch(fetchIGHashTags());
                toast.success(resp.data.message);
            })
            .catch((err) => toast.error(err.response.data.message));
    };
}

export function fetchInstagramBusinessAccount() {
    let account = [];
    let resp = axios
        .get(getUrl("social_token_list"), {
            cache: false,
            headers: { "Content-Type": "application/json; charset=UTF-8" },
        })

        .then((response) => response.data?.data?.tokens?.filter((ele) => ele.platform === "instagram"))
        .catch((err) => toast.error(err.response.data.message));
    return {
        type: ACTIVE_BUSINESS_ACCOUNT,
        payload: resp,
    };
}

export function gettingStartedProgress() {
    return function (dispatch) {
        axios
            .get(`${getUrl("get_progress")}`, {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                dispatch({
                    type: GET_PROGRESS,
                    payload: response?.data?.data,
                });
            })
            .catch((error) => {
                console.log(error);
                toast.error("Error in retaining your progress on the platform");
            });
    };
}
export function storeIgToken(userDetails) {
    return function (dispatch) {
        axios
            .get("https://graph.facebook.com/me/accounts?fields=name,instagram_business_account&access_token=" + userDetails["accessToken"], {
                cache: false,
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            })
            .then((api_data) => {
                if (api_data.data.data.length > 0) {
                    let buisness_accounts = [];
                    for (let i = 0; i < api_data.data.data.length; i++) {
                        if (api_data.data.data[i].instagram_business_account) {
                            buisness_accounts.push({
                                name: api_data.data.data[i].name,
                                id: api_data.data.data[i].instagram_business_account.id,
                            });
                        }
                    }
                    if (buisness_accounts.length == 0) {
                        toast.error("You do not have access to any valid Instagram Business Accounts.");
                    } else {
                        dispatch(
                            axios
                                .post(
                                    getUrl("store-social-tokens"),
                                    {
                                        platform: "InstagramGraph",
                                        platformId: "6ce32c0a-a789-11e4-a34f-74867a1157ba",
                                        name: userDetails.name,
                                        auth_token: userDetails.accessToken,
                                        buisness_accounts: buisness_accounts,
                                        token_source: "20Twenty",
                                        app_name: "20twentyIGApp",
                                    },
                                    {
                                        cache: false,
                                        headers: {
                                            "Content-Type": "application/json; charset=UTF-8",
                                        },
                                    },
                                )
                                .then(function (res) {
                                    toast.success("Your authorization was successful.");
                                    dispatch(fetchIGHashTags());
                                    dispatch(fetchInstagramBusinessAccount());
                                    dispatch(gettingStartedProgress());
                                })
                                .catch(function (err) {
                                    if (err.response.data.message) {
                                        toast.error(err.response.data.message);
                                    } else {
                                        toast.error("Error in Authorizing");
                                    }
                                }),
                        );
                    }
                } else {
                    toast.error("You do not have access to any valid Instagram Business Accounts.");
                }
            })
            .catch((err) => {
                console.log("error in graph api", err);
            });
    };
}
